<template functional>
  <p
    class="col-start-1 col-span-6 lg:col-start-2 lg:col-span-4 text-3-mob lg:text-4-desk"
    :class="data.staticClass || ''"
    v-bind="data.attrs"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: "ContentParagraph"
};
</script>
